import { render, staticRenderFns } from "./update-password.vue?vue&type=template&id=97ffe05c"
import script from "./update-password.vue?vue&type=script&lang=js"
export * from "./update-password.vue?vue&type=script&lang=js"
import style0 from "./update-password.vue?vue&type=style&index=0&id=97ffe05c&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/html/projects/subsapp-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('97ffe05c')) {
      api.createRecord('97ffe05c', component.options)
    } else {
      api.reload('97ffe05c', component.options)
    }
    module.hot.accept("./update-password.vue?vue&type=template&id=97ffe05c", function () {
      api.rerender('97ffe05c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/auth/update-password.vue"
export default component.exports